import request from '@/utils/request';

export function getMainBlockExplore(params) {
  return request({
    url: '/MainBlock/explore',
    params,
    silentRequest: true,
  });
}

export function getDynamicProductInfo(products) {
  return request({
    url: '/MainBlock/getDynamicProductInfo',
    method: 'POST',
    data: {
      products,
    },
    silentRequest: true,
  });
}
